function initStationsDataTable() {
  const tableElement = document.getElementById('stations-datatable');
  const fallbackElement = tableElement ? tableElement.querySelector('tbody') : null;

  // Not a stations page.
  if (!tableElement) {
    return;
  }

  const pageKey = `${window.location.pathname}${window.location.search}`;
  if (window.__xtrackerStationsDataTableInitKey === pageKey) {
    return;
  }
  window.__xtrackerStationsDataTableInitKey = pageKey;
  
  // Check if DataTables is available
  if (typeof jQuery !== 'undefined' && jQuery.fn.dataTable && tableElement) {
    // Destroy existing DataTable if it exists
    if ($.fn.DataTable.isDataTable('#stations-datatable')) {
      $('#stations-datatable').DataTable().destroy();
    }
    
    try {
      $("#stations-datatable").dataTable({
        responsive: true,
        scrollCollapse: true,
        sDom: '<"row view-filter txt"<"col-sm-12 txt"<"pull-left txt"l><"pull-right txt"f><"clearfix txt">>>t<"row view-pager txt"<"col-sm-12 p-2 txt"<"text-center txt"p>>>',
        processing: true,
        serverSide: true,
        pageLength: 10,
        language: {
          stripClasses: "",
          search: '<span class="txt text-sm mr-2 mt-2 text-white">Search</span>',
          searchPlaceholder: "Enter Keywords Here...",
          lengthMenu:
            '<span class="float-right txt text-sm mt-1 text-white">Rows per page</span><select class="float-right mr-2 input input-sm rounded-sm bg-slate-700 text-white border-slate-600">' +
            '<option value="10">10</option>' +
            '<option value="20">20</option>' +
            '<option value="30">30</option>' +
            '<option value="40">40</option>' +
            '<option value="50">50</option>' +
            '<option value="100">100</option>' +
            "</select>",
        },
        ajax: {
          url: $("#stations-datatable").data("source"),
          dataSrc: function(json) {
            console.log('DataTables received data:', json);
            console.log('Number of records:', json.data ? json.data.length : 'No data property');
            console.log('Total records:', json.recordsTotal);
            console.log('First record sample:', json.data[0]);
            return json.data;
          },
          error: function(xhr, error, code) {
            console.error('DataTables AJAX error:', error, code);
            console.error('Response status:', xhr.status);
            console.error('Response text:', xhr.responseText);
            // Show fallback content if AJAX fails
            if (fallbackElement) fallbackElement.style.display = '';
          }
        },
        pagingType: "simple_numbers",
        columns: [
          { data: "call_letters" },
          { data: "frequency" },
          { data: "station_type" },
          { data: "market" },
          { data: "actions", orderable: false }
        ],
        drawCallback: function(settings) {
          console.log('DataTable draw completed, rows:', settings.aoData.length);
        },
        initComplete: function(settings, json) {
          console.log('Stations DataTable initialized successfully');
          console.log('Initial data loaded:', json.data.length, 'records');
        }
      });
    } catch (error) {
      console.error('DataTable initialization failed:', error);
      // Ensure fallback content is visible
      if (fallbackElement) fallbackElement.style.display = '';
    }
  } else {
    console.log('Stations DataTable dependencies unavailable, using fallback content');
    // Ensure fallback content is visible
    if (fallbackElement) fallbackElement.style.display = '';
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initStationsDataTable);

// Also listen for turbo events in case Turbo gets enabled later
document.addEventListener('turbo:load', initStationsDataTable);

// Clean up before page cache
document.addEventListener("turbo:before-cache", function() {
  if (typeof jQuery !== 'undefined' && jQuery.fn.DataTable) {
    const table = $("#stations-datatable");
    if (table.length && $.fn.DataTable.isDataTable(table)) {
      table.DataTable().destroy();
    }
  }
  window.__xtrackerStationsDataTableInitKey = null;
});